const ImageTypeName = 'image';

export {
    ImageTypeName,
}